import { appWithTheme } from '@scorenco/components';
import {
  ApolloService,
  AmplifyService,
  SentryService,
  useTranslation,
} from '@scorenco/core';
import { AppLayout, AppPropsWithLayout } from '@scorenco/next';
import 'iframe-resizer/js/iframeResizer.contentWindow';
import Head from 'next/head';
import type { AppProps } from 'next/app';

import { TournoisLayout } from '../layouts/TournoisLayout';
import { T_KEYS } from '../translations';

TournoisLayout.init({
  i18n: {
    defaultLocale: 'fr',
    locales: ['fr'],
  },
  fallbackLng: ['fr'],
});

AmplifyService.init();

const App = (appProps: AppProps) => {
  const { t } = useTranslation();
  const layoutProps = appProps as AppPropsWithLayout;

  return (
    <SentryService>
      <ApolloService initialApolloState={appProps.pageProps.initialApolloState}>
        <AmplifyService>
          <Head>
            <title key="title">{t(T_KEYS.DEFAULT_HTML_TITLE)}</title>
          </Head>
          <AppLayout {...layoutProps} />
        </AmplifyService>
      </ApolloService>
    </SentryService>
  );
};

export default appWithTheme(TournoisLayout.appEnhancer(App));
